import * as React from "react";
import "./user.css";
import FollowedUser from "../searchUser/User";

export interface Props {
  users: any;
}
class UserList extends React.Component<Props, any> {
  render() {
    if (this.props.users) {
      const users = this.props.users.map(user => {
        return <FollowedUser key={user.uid} user={user} />;
      });
      return users;
    } else return null;
  }
}

export default UserList;



// WEBPACK FOOTER //
// ./src/components/searchUser/UserList.tsx